const moduloPerform = {
  agGrid: {
    paginacion: 15,
    id: 'myGrid',
    // class: 'ag-theme-material mt-3',
    class: 'ag-theme-alpine mt-3',
    style: {
      width: '100%',
      height: '700px'
    }
  },
  url: {
    conciliacionBancaria: {
      // conciBanc:'conci-banc/',
      // ConciBanca: 'param-conci-banca',

      banco: 'banco/findParam/',
      empresa: 'empresa',
      obtenerConci: '/paramAutoServiciosPK',
      bancoCuenta: 'bancoCuenta/findParam/',

      //extractoBancario: 'conci-banc-cobros/uploadFileForCuerpo',
      extractoBancario: '/cobros/uploadFileForCuerpo',
      getAllextractoBancario: 'conci-banc-cobros',
      autorizarCobros: {
        getCobrosPendientes: 'cobros/pending',
        rechazarCobro: '/cobros/rechazar/',
        procesarCobro: '/cobros/desbloquear-pago'
      },
      reportePerform: {
        findLote: 'report-perform/findLote',
        findEan14: 'report-perform/findEan',
        findReceta: 'report-perform/findReceta',
        generateReport: 'report-perform/find',
        generateReportDetail: 'report-perform/find-nogroup',
        generateReportSAP: 'report-perform-sap',
        generateReportGauss: 'insumo/bash',
        generateReportGaussFilter: 'report-perform/find-gauss',
        generateReportGaussFilterDetail: 'report-perform/find-gauss-detail',
        generateReportPareto: 'report-perform/pareto'
      },
      perform: {
        producto: 'performant/producto',
        productoFile: 'performant/producto/file',
        nodered: 'performant/node-red',
        plc: 'performant/plc',
        sendPlc: 'performant/plc/send-product',
        plcByPlanta: 'performant/plc/planta'
      },
      plc:{
        plcLinea: 'plc-linea',
        feriados: 'plc-linea/feriados',
        feriadosGuardar: 'plc-linea/guardar',
        eventos: 'evento/list-plc',
        ingresoArticulo: 'plc-linea/ingreso-articulo'
      },
      raspberry: {
        main: 'raspberry',
        mainParam: 'raspberry/param',
        mainConfig: 'raspberry/config',
        health: 'raspberry/health'
      },
      conciBancParam: 'conci-banc/param',
      conciBancparametro: 'conci-banc/parametro',
      findFormato: 'conci-banc/param/findFormato',
      findFormatoplus: 'conci-banc/parametro/findFormato',
      uploadDocSAP: 'conci-banc/uploadFileForSAP',
      uploadDocSAPplus: 'conci-banc/custom/uploadFileForSAP',
      uploadDoc: 'conci-banc/uploadFileForCuerpo',
      uploadDocplus: 'conci-banc/custom/uploadFileForCuerpo',
      reglasBanca: 'conci-banc/reglas-banca',

      DataBancaServ: 'conci-banca-servicios',
      clienteFind: 'cliente/findParam?cliDesde=',
      //parametros
      // idempresa: '?idEmpresa=',
      // idBanco: '&idBanco=',
    },
    seguimiento: {
      base: 'seguimiento/',
      reporte: 'seguimiento/reporte',
      baseLogPerform : 'seguimiento/perform/',
      reportePerform : 'seguimiento/perform/reporte'
    },
    plcPerform:{
      ordenProceso:'orden-proceso',
      perform:'perform',

    },
    productoSpecs:{
      base:'producto-specs'
    },
    productologs:{
      base:'producto-logs',
      search: 'producto-logs/search'
    },
    datosMaestros: {
      planta: 'planta',
      plantaPerfor: 'planta/perform',
      plantaPerforByUser: 'planta/performByUser/',
      linea: 'linea',
      baanMaquina: 'linea/baan-maquina',
      lineaHomologada: 'linea/homologada',
      lineaPerfor: 'linea/lineasByCodigoPlantaPerfor',
      persona: 'persona',
      lineaPersona: 'linea-persona',
      producto: 'producto',
      plantaPersona: 'planta-persona',
      eventos: 'evento',
      plantaLineaPersona: 'linea/planta-persona',
      empresa: 'empresa',
      lineasMetas: 'lineas-metas'
    },
    parametros: {
      idempresa: '?idEmpresa=',
      idBanco: '&idBanco=',
    },
    basculaLinea: {
      crudBascula : 'bascula-linea',
      crudPesos   : 'bascula-pesos',
      capturaPeso : 'bascula-gramera',
      
    },
    parada: {
        getLineasPersonas: 'getLineasPersonas',
        getProductosPorLineas: 'getProductos-por-lineas',
        parada: 'parada',
        paradaWeb: 'parada/web',
        lineaInfo: 'last-parada',
        eventos: 'eventos',
        unidadesProducidas: 'unidades-producidas',
        unidadesProducidasLineas: 'unidades-producidas-linea',
        reporteParada: 'report',
        reporteIndicadoresTVC: 'indicador-tvc-linea',
        reporteIndicadorTVCTablero: 'indicador-tvc-linea/linea',
        indicadorTvcLineaParam:'indicador-tvc-linea/param',
        actualizarDescripcion: 'actualizar-descripcion',
        electricista: 'reporte/electrisista',
        elementoLaboratorio: 'reporte/parada/elemento',
        laboratorio: 'laboratorio',
        rechazoRetiro: 'rechazo-retiro',
        reporteProdpro: 'reporte/produccion/producto/',
        reportMotivo: 'report/motivo/',
        eventoContador: 'evento/contador/',
        eventoContadorSeccion: 'evento/contador-seccion',
        eventoContadorTablero: 'evento/contador-tablero-control',
        reporteProdproTablero: 'reporte/produccion/producto-tablero-control',
        reportMotivoTablero: 'report/motivo-tablero-control',
        resportAnio: 'reporte/anio-parada'
    },
  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',
      primaryOutline: 'btn btn-outline-primary',
      secondaryOutline: 'btn btn-outline-secondary',
      successOutline: 'btn btn-outline-success',
      dangerOutline: 'btn btn-outline-danger',
      warningOutline: 'btn btn-outline-warning',
      infoOutline: 'btn btn-outline-info',
      lightOutline: 'btn btn-outline-light',
      darkOutline: 'btn btn-outline-dark',
      primarylg: 'btn btn-primary btn-lg btn-block',
    },
    buttonsNombre: {
      editar: 'Editar',
      ver: 'Ver',
      eliminar: 'Eliminar',
      agregar: 'Agregar ',
      guardar: 'Guardar',
      actualizar: 'Actualizar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      seleccionar: 'Seleccionar',
      procesar: 'Procesar',
      sustento: 'Sustento',
      validar: 'Validar',
      descargar: 'Descargar',
      descargarRecibo: 'Descargar Recibo Cobros',
      descargarEstado: 'Descargar Estados Docs',
      catalogo: 'Añadir Catalogo',
      buscar: 'Buscar',
      verPedidos: 'Ver Pedidos',
      rechazar: 'Rechazar'
    }
  },
  mensajes: {
    errorServicio : 'error..!!',
    desabilitada  : 'Opción desabilitada',
    eliminar      : '¿Esta seguro que desea eliminar el siguiente elemento?',
    guardar       : '¿Esta seguro que desea guardar el siguiente elemento?',
    actualizar    : '¿Esta seguro que desea actualizar el siguiente elemento?',
    datoGuardado  : 'Se guardo corectamente..!!',
    guardarParada : 'Esta seguro que desea registrar este evento..??',
    procesar      : '¿Esta seguro que desea procesar el siguiente elemento?',
    validar       : '¿Esta seguro que desea validar el siguiente elemento?',
    anticipo      : 'Se tomara este valor como anticipo.',
  },
  titulos: {
    autorizacionCobros: {
      titulo: 'Reporte Perfor',
      modulo: 'io-industrias',
      tituloCardListar: 'Reporte perfor',
      tituloCardGuardar: 'Guardar Perfor',
      tituloCardEditar: 'Editar Editar perfor',
      tituloCardPedidos: 'Perfor',
      tituloCardProcesarExtractos: 'Procesar Perfor',
    },
    balanzaPlanta: {
      titulo: 'Mantener Basculas relacionadas con Plantas',
      modulo: 'IO-Industrias',
      tituloCardListar: 'Balanzas',
      tituloCardGuardar: 'Guardar Registro',
      tituloCardEditar: 'Editar Registro',
    },
    capturardora: {
      titulo: 'Capturadora pesos en Linea',
      modulo: 'IO-Industrias',
      tituloCardListar: 'Planta y Líneas',
      tituloCardGuardar: 'Guardar Registro',
      tituloCardEditar: 'Editar Registro',
    },
  }

}


export {moduloPerform}
